import { IObjective, ObjectiveType } from "apps/diagnostics/models/IObjective";

const DEFAULT_OBJECTIVE_NAME = "Objective";
const OBJECTIVE_NAME_FROM_TEXT_MAX_LENGTH = 60;

export interface IObjectiveCopyBody {
  name: string;
  description?: string;
  text: string;
  sampleQuestions?: { text: string; required: boolean }[];
  maxQuestions?: number;
  order?: number;
  questionNumber?: number;
  objectiveType?: ObjectiveType;
  allowSkipping?: boolean;
  selectOptions?: Record<string, string>;
}

export const getObjectiveCopyName = (objective: IObjective): string => {
  return (
    objective.name?.trim() ||
    objective.text.trim().slice(0, OBJECTIVE_NAME_FROM_TEXT_MAX_LENGTH) ||
    DEFAULT_OBJECTIVE_NAME
  );
};

export const buildObjectiveCopyBody = (
  objective: IObjective,
): IObjectiveCopyBody => {
  return {
    name: getObjectiveCopyName(objective),
    description: objective.description,
    text: objective.text,
    sampleQuestions: objective.sampleQuestions
      ? [...objective.sampleQuestions]
      : undefined,
    maxQuestions: objective.maxQuestions ?? undefined,
    order: objective.order ?? undefined,
    questionNumber: objective.questionNumber ?? undefined,
    objectiveType: objective.objectiveType ?? undefined,
    allowSkipping: objective.allowSkipping ?? undefined,
    selectOptions: objective.selectOptions
      ? { ...objective.selectOptions }
      : undefined,
  };
};
